module.exports = __webpack_public_path__ + "img/IMG_8922.6c31adb8.jpg";